var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23467 4.29781C1.25684 4.09066 1.51419 4.03987 1.63272 4.21121L3.61774 7.08077C4.16644 7.87398 5.36073 7.80303 5.81166 6.95045L8.73129 1.43026C8.78407 1.33048 8.88769 1.26807 9.00056 1.26807C9.11343 1.26807 9.21705 1.33048 9.26982 1.43026L12.1895 6.95045C12.6404 7.80303 13.8347 7.87398 14.3834 7.08077L16.3684 4.21121C16.4869 4.03987 16.7443 4.09066 16.7664 4.29781C16.9127 5.66518 17.0363 7.06901 17.0363 8.50021C17.0363 9.93141 16.9127 11.3352 16.7664 12.7026C16.5683 14.5549 15.0785 16.0446 13.2271 16.251C11.852 16.4043 10.4401 16.5359 9.00056 16.5359C7.56103 16.5359 6.14911 16.4043 4.77397 16.251C2.92261 16.0446 1.43284 14.5549 1.23467 12.7026C1.08838 11.3352 0.964844 9.93141 0.964844 8.50021C0.964844 7.06901 1.08838 5.66518 1.23467 4.29781Z",
    fill: "white",
    fillOpacity: 0.3,
    stroke: "white",
    strokeWidth: 1.92857,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.4914b70b6c64a2a3a789ac4676425fd7.svg";
export { ForwardRef as ReactComponent };